import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import { GreyPallet } from "../../../config/styles";

export const CustomBox = styled(Box)({
  marginBottom: 16,
  "& .MuiTypography-root": {
    fontWeight: "bold",
    color: GreyPallet.Regular,
  },
  color: GreyPallet.Black,
  "& .MuiFormControlLabel-root": {
    justifyContent: "space-between",
    marginLeft: 0,
  },
  backgroundColor: GreyPallet.Light,
  borderRadius: "15px",
  padding: "8px 16px",
});
